import { StateCreator } from 'zustand';

import { Site } from 'src/models/Site.model';

import { RemoteBoundStoreState } from './useRemoteBoundStore';

interface StateTypes {
  sites: Site[];
}

type ActionsTypes = {
  setSites: (sites: Site[]) => void;
  resetSites: () => void;
};

export type SitesSliceTypes = StateTypes & ActionsTypes;

const initialState: StateTypes = {
  sites: [],
};

export const createSitesSlice: StateCreator<
  RemoteBoundStoreState,
  [],
  [],
  SitesSliceTypes
> = (set) => ({
  ...initialState,

  setSites: (sites: Site[]) => set({ sites }),

  resetSites: () => set({ sites: [] }),
});
